import { type FC, memo } from "react";
import { type KeyValue, KeyValueTable } from "@/components/fragments/table/key-value-table";
import { Box } from "@/components/essentials/box";
import { Typography } from "@/components/essentials/typography";
import { planDataTableTestId, planDataTableTitleTestId } from "./const";
import { Price } from "./__components__/price";
import { type PlanData } from "./type";
import { isNonNullable } from "@/modules/utils/predicate";

export interface PlanDataTableProps {
  readonly data: PlanData;
  readonly promotionCode?: string | undefined;
}

export const PlanDataTable: FC<PlanDataTableProps> = memo(({ data, promotionCode = "" }) => {
  const planKeyValueData: KeyValue[] = [
    {
      key: "商品名",
      value: data.name,
    },
    {
      key: "金額（税込）",
      value: <Price data={data} promotionCode={promotionCode} />,
    },
  ];

  if (isNonNullable(promotionCode) && promotionCode !== "") {
    planKeyValueData.push({
      key: "プロモーションコード",
      value: promotionCode,
    });
  }

  return (
    <Box data-testid={planDataTableTestId}>
      <Typography variant="display6" mb="2" data-testid={planDataTableTitleTestId}>
        お申し込み中の商品情報
      </Typography>
      <KeyValueTable data={planKeyValueData} />
    </Box>
  );
});

PlanDataTable.displayName = "PlanDataTable";
